import { TFunction } from 'i18next';

import Step1Image from '@/assets/tours/capital/1.png';
import Step2Image from '@/assets/tours/capital/2.png';
import Step3Image from '@/assets/tours/capital/3.png';
import Step4Image from '@/assets/tours/capital/4.png';
import { AccountResponse } from '@/types';

export const getCapitalTourSteps = (
  t: TFunction<'translation', undefined>,
): any[] => {
  return [
    {
      target: '#portfolio-chart',
      disableBeacon: true,
      placement: 'right-start' as const,
      image: Step1Image,
      title: t('vestCapital.tour.step1Title'),
      content: t('vestCapital.tour.step1Text'),
    },
    {
      target: '#goals',
      placement: 'left-start' as const,
      image: Step2Image,
      title: t('vestCapital.tour.step2Title'),
      content: (
        <>
          {t('vestCapital.tour.step2Text1')}
          <br />
          <br />
          {t('vestCapital.tour.step2Text2')}
        </>
      ),
    },
    {
      target: '#account-health',
      placement: 'left-start' as const,
      image: Step3Image,
      title: t('vestCapital.tour.step3Title'),
      content: (
        <>
          {t('vestCapital.tour.step3Text1')}
          <br />
          <br />
          {t('vestCapital.tour.step3Text2')}
        </>
      ),
    },
    {
      target: '#portfolio-tables',
      placement: 'top' as const,
      image: Step4Image,
      title: t('vestCapital.tour.step4Title'),
      content: (
        <>
          {t('vestCapital.tour.step4Text1')}
          <br />
          <br />
          {t('vestCapital.tour.step4Text2')}
        </>
      ),
    },
  ];
};

export const getCapitalDemoAccount = (
  currentAccount: AccountResponse,
): AccountResponse => {
  const demoBalance = (
    +(currentAccount?.balances?.[0]?.total ?? '0') * 1.05
  ).toString();

  return {
    ...currentAccount,
    balances: [
      {
        asset: 'USDC',
        locked: '0.000000',
        total: demoBalance,
      },
    ],
    collateral: demoBalance,
    time: currentAccount.time + 1,
    positions: [
      {
        symbol: 'NVDA-USD-PERP',
        isLong: true,
        size: '3.5405',
        entryPrice: '165.02',
        entryFunding: '3.672278125777',
        unrealizedPnl: '-10.701875',
        fundingPaid: '-0.064160',
        markPrice: '181.99',
        indexPrice: '181.99',
        liqPrice: '',
        initMargin: '19.673119',
        maintMargin: '0.983656',
        initMarginRatio: '0.2',
      },
      {
        symbol: 'GOOGL-USD-PERP',
        isLong: false,
        size: '2.6080',
        entryPrice: '375.83',
        entryFunding: '4.972003407418',
        unrealizedPnl: '2.448707',
        fundingPaid: '-0.129213',
        markPrice: '333.07',
        indexPrice: '333.03',
        liqPrice: '',
        initMargin: '40.496448',
        maintMargin: '2.024823',
        initMarginRatio: '0.2',
      },
      {
        symbol: 'ETH-PERP',
        isLong: true,
        size: '0.082',
        entryPrice: '3750.095',
        entryFunding: '11834.343379378591',
        unrealizedPnl: '9.365535',
        fundingPaid: '-0.141665',
        markPrice: '3382.195',
        indexPrice: '3382.429',
        liqPrice: '',
        initMargin: '21.647546',
        maintMargin: '1.082378',
        initMarginRatio: '0.2',
      },
    ],
  };
};
